import { IWarning } from 'redux-state/weather-warnings/types.js';
import {
  getSeverityInfo,
  ISeverity,
  WarningSeverity,
  warnLevelHighest,
} from 'utilities/weather-warnings/warning-severity.js';
import { IForecastDayTab } from '../types.js';

export const getForecastSeverities = (days: IForecastDayTab[]): ISeverity[] => {
  const warningSeverities = days.map((day) => {
    return getForecastSeverity(day);
  });
  return warningSeverities;
};

export const getForecastSeverity = ({ warnings }: { warnings?: IWarning[] | undefined }): ISeverity => {
  const warningsSeverity = warnings?.length ? warnLevelHighest(warnings.map(({ warnLevel }) => warnLevel)) : '';
  return getSeverityInfo(warningsSeverity || WarningSeverity.None);
};
